export default "__VITE_ASSET__DYDMDCw5__"